const faqs = [
  {
    q: '在线吃瓜是什么网站？安全吗？',
    a: '在线吃瓜是一个免费娱乐八卦内容聚合平台，我们仅聚合互联网公开内容并提供便捷浏览入口，不存储任何用户数据，完全匿名浏览，安全可靠。',
  },
  {
    q: '需要注册或付费才能看内容吗？',
    a: '完全不需要！在线吃瓜所有内容永久免费开放，无需注册账号，无需支付任何费用，打开浏览器就能畅快吃瓜，没有任何付费墙或会员体系。',
  },
  {
    q: '内容多久更新一次？都是最新的吗？',
    a: '我们每天实时追踪全网热点，内容每日多次更新，确保你看到的是最新最热的吃瓜内容。热点专题由编辑团队人工筛选，保证质量和时效性。',
  },
  {
    q: '可以投稿爆料吗？怎么联系你们？',
    a: '当然可以！我们非常欢迎瓜友投稿。你可以在本页的「投稿爆料」区域找到联系方式，或直接发送邮件给我们，编辑团队会尽快审核处理。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-16 md:py-20 px-4 md:px-6 scroll-mt-20">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            关于在线吃瓜，你想知道的都在这里
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-2xl border border-background-200/60 p-5 md:p-6"
            >
              <h3 className="text-base font-semibold text-foreground-900 mb-2 flex items-start gap-3">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-line"></i>
                </span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed pl-7">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}